import { useLiveUserRole } from "./useLiveUserRole";
import { useAccessRight } from "./useAccessRight";
import {
  ACTION_ACCESS_HIDDEN,
  ACTION_ACCESS_ACCESSIBLE,
  getDefaultActionAccess,
} from "../data/actionRegistry";

const toAccessRight = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : ACTION_ACCESS_HIDDEN;
};

/**
 * Per-button action permissions from userRole.actionLinks.
 * Uses the live role document so role-editor Disable applies without re-login.
 */
export const useActionRight = () => {
  const userRole = useLiveUserRole();
  const [, rawPageAccessRight] = useAccessRight();
  const pageAccessRight = toAccessRight(rawPageAccessRight);

  const getActionRight = (entity, action) => {
    const entry = userRole?.actionLinks?.find(
      (a) => a.entity === entity && a.action === action
    );
    if (!entry || entry.accessRight == null) {
      return toAccessRight(getDefaultActionAccess(entity, action));
    }
    return toAccessRight(entry.accessRight);
  };

  const isActionVisible = (entity, action) => {
    if (pageAccessRight === 0) return false;
    return getActionRight(entity, action) !== ACTION_ACCESS_HIDDEN;
  };

  /**
   * The button's own access decides whether it can be used.
   * A Read Only page does not turn an Accessible button off.
   */
  const isActionEnabled = (entity, action) => {
    if (!isActionVisible(entity, action)) return false;
    return getActionRight(entity, action) === ACTION_ACCESS_ACCESSIBLE;
  };

  /** @deprecated use isActionEnabled */
  const canAccessAction = isActionEnabled;

  return {
    getActionRight,
    isActionVisible,
    isActionEnabled,
    canAccessAction,
    pageAccessRight,
  };
};
